module.exports = __webpack_public_path__ + "img/freeagent-logo.bb28a993.webp";